import { __decorate, __param, __rest } from 'tslib';
import { Component, ChangeDetectionStrategy, InjectionToken, inject, Inject, ElementRef, ViewChild, ViewEncapsulation, TemplateRef, Injector, ApplicationRef, ComponentFactoryResolver, ɵɵdefineInjectable, ɵɵinject, INJECTOR, Injectable, Optional, Input, HostListener, Directive, EventEmitter, NgZone, Renderer2, Output, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { of, from, merge, Subject, fromEvent } from 'rxjs';
import { filter, defaultIfEmpty, first, takeUntil, map, switchMap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function BaseDialogComponent_h2_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "h2", 10);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.title.content, ɵngcc0.ɵɵsanitizeHtml);
} }
function BaseDialogComponent_h2_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BaseDialogComponent_h2_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2");
    ɵngcc0.ɵɵtemplate(1, BaseDialogComponent_h2_6_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.title.content)("ngTemplateOutletContext", ctx_r1.context);
} }
function BaseDialogComponent_p_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p", 10);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("with-title", ctx_r2.title);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.body.content, ɵngcc0.ɵɵsanitizeHtml);
} }
function BaseDialogComponent_p_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BaseDialogComponent_p_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtemplate(1, BaseDialogComponent_p_9_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("with-title", ctx_r3.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.body.content)("ngTemplateOutletContext", ctx_r3.context);
} }
const _c0 = [[["", 8, "icon"]], [["", 8, "btn"]]];
const _c1 = [".icon", ".btn"];
const _c2 = "[_nghost-%COMP%]{display:flex;flex-direction:column;flex-grow:1;overflow:hidden}";
const _c3 = ["backdrop"];
const _c4 = ["dialog"];
function DialogComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("dialogDragEnabled", true)("dialogDragTarget", _r1);
} }
function DialogComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_div_5_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.closeDialog(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 8);
    ɵngcc0.ɵɵelement(2, "path", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
class DialogRef {
}
class InternalDialogRef extends DialogRef {
    constructor(props = {}) {
        super();
        this.beforeCloseGuards = [];
        this.mutate(props);
    }
    close(result) {
        this.canClose(result)
            .pipe(filter(Boolean))
            .subscribe({ next: () => this.onClose(result) });
    }
    beforeClose(guard) {
        this.beforeCloseGuards.push(guard);
    }
    canClose(result) {
        const guards$ = this.beforeCloseGuards
            .map(guard => guard(result))
            .filter(value => value !== undefined && value !== true)
            .map(value => {
            return typeof value === 'boolean' ? of(value) : from(value).pipe(filter(canClose => !canClose));
        });
        return merge(...guards$).pipe(defaultIfEmpty(true), first());
    }
    mutate(props) {
        Object.assign(this, props);
    }
    asDialogRef() {
        return this;
    }
}

function isNil(value) {
    return value === undefined || value === null;
}
function isString(value) {
    return typeof value === 'string';
}
function coerceCssPixelValue(value) {
    if (isNil(value)) {
        return '';
    }
    return isString(value) ? value : `${value}px`;
}

const DialogContentSymbol = Symbol('Dialog Content Data');

let BaseDialogComponent = class BaseDialogComponent {
    constructor(ref) {
        this.ref = ref;
        this.title = this.ref.data[DialogContentSymbol].title;
        this.body = this.ref.data[DialogContentSymbol].body;
        this.context = {
            $implicit: this.ref,
            data: this.ref.data
        };
    }
};
BaseDialogComponent.ɵfac = function BaseDialogComponent_Factory(t) { return new (t || BaseDialogComponent)(ɵngcc0.ɵɵdirectiveInject(DialogRef)); };
BaseDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BaseDialogComponent, selectors: [["ngneat-dialog-base"]], ngContentSelectors: _c1, decls: 12, vars: 6, consts: [[1, "dialog"], [1, "dialog-header"], [1, "dialog-icon"], [3, "ngSwitch"], [3, "innerHTML", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [1, "dialog-content", 3, "ngSwitch"], [3, "with-title", "innerHTML", 4, "ngSwitchCase"], [3, "with-title", 4, "ngSwitchCase"], [1, "dialog-footer"], [3, "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function BaseDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerStart(4, 3);
        ɵngcc0.ɵɵtemplate(5, BaseDialogComponent_h2_5_Template, 1, 1, "h2", 4);
        ɵngcc0.ɵɵtemplate(6, BaseDialogComponent_h2_6_Template, 2, 2, "h2", 5);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, BaseDialogComponent_p_8_Template, 1, 3, "p", 7);
        ɵngcc0.ɵɵtemplate(9, BaseDialogComponent_p_9_Template, 2, 4, "p", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵprojection(11, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.title == null ? null : ctx.title.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "string");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "template");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.body.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "string");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "template");
    } }, directives: [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;overflow:hidden;flex-grow:1}.dialog[_ngcontent-%COMP%]{flex-grow:1;display:flex;align-items:center;flex-direction:column;justify-content:flex-start;overflow:hidden}.dialog-header[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:row;align-items:center;width:100%;margin:0;padding:18px 40px 10px 30px}.dialog-header[_ngcontent-%COMP%]   .dialog-icon[_ngcontent-%COMP%]    {display:flex}.dialog-header[_ngcontent-%COMP%]   .dialog-icon[_ngcontent-%COMP%]     .icon{width:24px;margin-right:10px}.dialog-header[_ngcontent-%COMP%]   .dialog-icon[_ngcontent-%COMP%]     .icon-success{fill:#72c140}.dialog-header[_ngcontent-%COMP%]   .dialog-icon[_ngcontent-%COMP%]     .icon-question{fill:#f0af41}.dialog-header[_ngcontent-%COMP%]   .dialog-icon[_ngcontent-%COMP%]     .icon-error{fill:#e74c3c}.dialog-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:1.2rem;font-weight:700;margin:0}.dialog-content[_ngcontent-%COMP%]{width:100%;flex-grow:1;overflow:auto;position:relative;display:flex;flex-direction:column;padding:0 30px 30px}.dialog-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:.875rem;line-height:1.75;margin:5px 0}.dialog-content[_ngcontent-%COMP%]   .with-title[_ngcontent-%COMP%]{padding-left:35px}.dialog-footer[_ngcontent-%COMP%]    {display:flex;width:100%;justify-content:flex-end;padding:17px 30px 16px;border-top:1px solid #f1f2f5}.dialog-footer[_ngcontent-%COMP%]     .btn{margin-right:10px;padding:10px 18px;border:0;border-radius:4px;cursor:pointer}.dialog-footer[_ngcontent-%COMP%]     .btn:focus{outline:0}.dialog-footer[_ngcontent-%COMP%]     .btn:last-child{margin-right:0}.dialog-footer[_ngcontent-%COMP%]     .btn-success{background-color:#4091f7;color:#fff}.dialog-footer[_ngcontent-%COMP%]     .btn-error{background-color:#e74c3c;color:#fff}.dialog-footer[_ngcontent-%COMP%]     .btn-cancel{background-color:#fff;border:2px solid #4091f7;color:#4091f7}"], changeDetection: 0 });
BaseDialogComponent.ctorParameters = () => [
    { type: DialogRef }
];

let SuccessDialogComponent = class SuccessDialogComponent extends BaseDialogComponent {
};
SuccessDialogComponent.ɵfac = function SuccessDialogComponent_Factory(t) { return ɵSuccessDialogComponent_BaseFactory(t || SuccessDialogComponent); };
SuccessDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SuccessDialogComponent, selectors: [["ngneat-dialog-success"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 0, consts: [["x", "0px", "y", "0px", "viewBox", "0 0 496 496", 1, "icon", "icon-success"], ["d", "M248,0C111.033,0,0,111.033,0,248s111.033,248,248,248s248-111.033,248-248C495.841,111.099,384.901,0.159,248,0z      M248,480C119.87,480,16,376.13,16,248S119.87,16,248,16s232,103.87,232,232C479.859,376.072,376.072,479.859,248,480z"], ["d", "M370.344,158.344L208,320.688l-82.344-82.344c-3.178-3.07-8.242-2.982-11.312,0.196c-2.994,3.1-2.994,8.015,0,11.116     l88,88c3.124,3.123,8.188,3.123,11.312,0l168-168c3.07-3.178,2.982-8.242-0.196-11.312     C378.359,155.35,373.444,155.35,370.344,158.344z"], [1, "btn", "btn-success", "ngneat-dialog-primary-btn", 3, "click"]], template: function SuccessDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngneat-dialog-base");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 0);
        ɵngcc0.ɵɵelementStart(2, "g");
        ɵngcc0.ɵɵelement(3, "path", 1);
        ɵngcc0.ɵɵelement(4, "path", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function SuccessDialogComponent_Template_button_click_5_listener() { return ctx.ref.close(); });
        ɵngcc0.ɵɵtext(6, "OK");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [BaseDialogComponent], styles: [_c2], changeDetection: 0 });

let ConfirmDialogComponent = class ConfirmDialogComponent extends BaseDialogComponent {
};
ConfirmDialogComponent.ɵfac = function ConfirmDialogComponent_Factory(t) { return ɵConfirmDialogComponent_BaseFactory(t || ConfirmDialogComponent); };
ConfirmDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmDialogComponent, selectors: [["ngneat-dialog-confirm"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 0, consts: [["x", "0px", "y", "0px", "viewBox", "0 0 512 512", 1, "icon", "icon-question"], ["cx", "256", "cy", "378.5", "r", "25"], ["d", "M256,0C114.516,0,0,114.497,0,256c0,141.484,114.497,256,256,256c141.484,0,256-114.497,256-256     C512,114.516,397.503,0,256,0z M256,472c-119.377,0-216-96.607-216-216c0-119.377,96.607-216,216-216     c119.377,0,216,96.607,216,216C472,375.377,375.393,472,256,472z"], ["d", "M256,128.5c-44.112,0-80,35.888-80,80c0,11.046,8.954,20,20,20s20-8.954,20-20c0-22.056,17.944-40,40-40     c22.056,0,40,17.944,40,40c0,22.056-17.944,40-40,40c-11.046,0-20,8.954-20,20v50c0,11.046,8.954,20,20,20     c11.046,0,20-8.954,20-20v-32.531c34.466-8.903,60-40.26,60-77.469C336,164.388,300.112,128.5,256,128.5z"], [1, "btn", "btn-cancel", "ngneat-dialog-secondary-btn", 3, "click"], [1, "btn", "btn-success", "ngneat-dialog-primary-btn", 3, "click"]], template: function ConfirmDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngneat-dialog-base");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 0);
        ɵngcc0.ɵɵelementStart(2, "g");
        ɵngcc0.ɵɵelement(3, "circle", 1);
        ɵngcc0.ɵɵelement(4, "path", 2);
        ɵngcc0.ɵɵelement(5, "path", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(6, "button", 4);
        ɵngcc0.ɵɵlistener("click", function ConfirmDialogComponent_Template_button_click_6_listener() { return ctx.ref.close(false); });
        ɵngcc0.ɵɵtext(7, "Cancel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵlistener("click", function ConfirmDialogComponent_Template_button_click_8_listener() { return ctx.ref.close(true); });
        ɵngcc0.ɵɵtext(9, "OK");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [BaseDialogComponent], styles: [_c2], changeDetection: 0 });

let ErrorDialogComponent = class ErrorDialogComponent extends BaseDialogComponent {
};
ErrorDialogComponent.ɵfac = function ErrorDialogComponent_Factory(t) { return ɵErrorDialogComponent_BaseFactory(t || ErrorDialogComponent); };
ErrorDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ErrorDialogComponent, selectors: [["ngneat-dialog-error"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 0, consts: [["x", "0px", "y", "0px", "viewBox", "0 0 512 512", 1, "icon", "icon-error"], ["d", "M256,0C114.508,0,0,114.497,0,256c0,141.493,114.497,256,256,256c141.492,0,256-114.497,256-256    C512,114.507,397.503,0,256,0z M256,472c-119.384,0-216-96.607-216-216c0-119.385,96.607-216,216-216    c119.384,0,216,96.607,216,216C472,375.385,375.393,472,256,472z"], ["d", "M343.586,315.302L284.284,256l59.302-59.302c7.81-7.81,7.811-20.473,0.001-28.284c-7.812-7.811-20.475-7.81-28.284,0    L256,227.716l-59.303-59.302c-7.809-7.811-20.474-7.811-28.284,0c-7.81,7.811-7.81,20.474,0.001,28.284L227.716,256    l-59.302,59.302c-7.811,7.811-7.812,20.474-0.001,28.284c7.813,7.812,20.476,7.809,28.284,0L256,284.284l59.303,59.302    c7.808,7.81,20.473,7.811,28.284,0C351.398,335.775,351.397,323.112,343.586,315.302z"], [1, "btn", "btn-error", "ngneat-dialog-primary-btn", 3, "click"]], template: function ErrorDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngneat-dialog-base");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 0);
        ɵngcc0.ɵɵelementStart(2, "g");
        ɵngcc0.ɵɵelement(3, "path", 1);
        ɵngcc0.ɵɵelement(4, "path", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function ErrorDialogComponent_Template_button_click_5_listener() { return ctx.ref.close(); });
        ɵngcc0.ɵɵtext(6, "OK");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [BaseDialogComponent], styles: [_c2], changeDetection: 0 });

const DIALOG_DOCUMENT_REF = new InjectionToken('A reference to the document. Useful for iframes that want appends to parent window', {
    providedIn: 'root',
    factory() {
        return inject(DOCUMENT);
    }
});
const GLOBAL_DIALOG_CONFIG = new InjectionToken('Global dialog config token');
const DIALOG_CONFIG = new InjectionToken('Dialog config token', {
    providedIn: 'root',
    factory: () => ({
        id: undefined,
        container: inject(DIALOG_DOCUMENT_REF).body,
        backdrop: true,
        closeButton: true,
        enableClose: true,
        draggable: false,
        resizable: false,
        size: 'md',
        windowClass: undefined,
        width: undefined,
        height: undefined,
        minHeight: undefined,
        maxHeight: undefined,
        data: undefined,
        vcr: undefined,
        sizes: {
            sm: {
                minHeight: '200px',
                width: '400px'
            },
            md: {
                minHeight: '280px',
                width: '560px'
            },
            lg: {
                minHeight: '350px',
                width: '800px'
            },
            fullScreen: {
                height: '100%',
                width: '100%'
            }
        },
        success: {
            component: SuccessDialogComponent
        },
        confirm: {
            component: ConfirmDialogComponent
        },
        error: {
            component: ErrorDialogComponent
        },
        onClose: undefined,
        onOpen: undefined
    })
});
const NODES_TO_INSERT = new InjectionToken('Nodes inserted into the dialog');

let DialogComponent = class DialogComponent {
    constructor(document, { nativeElement: host }, dialogRef, config, nodes) {
        var _a, _b, _c, _d, _e;
        this.document = document;
        this.dialogRef = dialogRef;
        this.config = config;
        this.nodes = nodes;
        this.size = (_a = this.config.sizes) === null || _a === void 0 ? void 0 : _a[this.config.size || 'md'];
        this.styles = {
            width: coerceCssPixelValue(this.config.width || ((_b = this.size) === null || _b === void 0 ? void 0 : _b.width)),
            height: coerceCssPixelValue(this.config.height || ((_c = this.size) === null || _c === void 0 ? void 0 : _c.height)),
            minHeight: coerceCssPixelValue(this.config.minHeight || ((_d = this.size) === null || _d === void 0 ? void 0 : _d.minHeight)),
            maxHeight: coerceCssPixelValue(this.config.maxHeight || ((_e = this.size) === null || _e === void 0 ? void 0 : _e.maxHeight))
        };
        this.destroy$ = new Subject();
        host.id = this.config.id;
        // Append nodes to dialog component, template or component could need
        // something from the dialog component
        // for example, if `[dialogClose]` is used into a directive,
        // DialogRef will be getted from DialogService instead of DI
        this.nodes.forEach(node => host.appendChild(node));
        if (config.windowClass) {
            const classNames = config.windowClass.split(/\s/).filter(x => x);
            classNames.forEach(name => host.classList.add(name));
        }
    }
    ngOnInit() {
        const backdrop = this.config.backdrop ? this.backdrop.nativeElement : this.document.body;
        const dialogElement = this.dialogElement.nativeElement;
        const backdropClick$ = fromEvent(backdrop, 'click').pipe(filter(({ target }) => !dialogElement.contains(target)));
        backdropClick$.pipe(takeUntil(this.destroy$)).subscribe(this.dialogRef.backdropClick$);
        if (this.config.enableClose) {
            merge(fromEvent(this.document.body, 'keyup').pipe(filter(({ key }) => key === 'Escape')), backdropClick$)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => this.closeDialog());
        }
        // `dialogElement` is resolvesd at this point
        // And here is where dialog finally will be placed
        this.nodes.forEach(node => dialogElement.appendChild(node));
    }
    closeDialog() {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.dialogRef = null;
        this.nodes = null;
    }
};
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(InternalDialogRef), ɵngcc0.ɵɵdirectiveInject(DIALOG_CONFIG), ɵngcc0.ɵɵdirectiveInject(NODES_TO_INSERT)); };
DialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["ngneat-dialog"]], viewQuery: function DialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c3, true);
        ɵngcc0.ɵɵstaticViewQuery(_c4, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.backdrop = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dialogElement = _t.first);
    } }, decls: 6, vars: 8, consts: [[1, "ngneat-dialog-backdrop", 3, "hidden"], ["backdrop", ""], [1, "ngneat-dialog-content", 3, "ngStyle"], ["dialog", ""], ["class", "ngneat-drag-marker", "dialogDraggable", "", 3, "dialogDragEnabled", "dialogDragTarget", 4, "ngIf"], ["class", "ngneat-close-dialog", 3, "click", 4, "ngIf"], ["dialogDraggable", "", 1, "ngneat-drag-marker", 3, "dialogDragEnabled", "dialogDragTarget"], [1, "ngneat-close-dialog", 3, "click"], ["viewBox", "0 0 329.26933 329", "xmlns", "http://www.w3.org/2000/svg"], ["fill", "currentColor", "d", "m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵtemplate(4, DialogComponent_div_4_Template, 1, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(5, DialogComponent_div_5_Template, 3, 0, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ngneat-dialog-backdrop-visible", ctx.config.backdrop);
        ɵngcc0.ɵɵproperty("hidden", !ctx.config.backdrop);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("ngneat-dialog-resizable", ctx.config.resizable);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.styles);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.draggable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.enableClose && ctx.config.closeButton);
    } }, directives: function () { return [ɵngcc1.NgStyle, ɵngcc1.NgIf, DialogDraggableDirective]; }, styles: [".ngneat-dialog-content{display:flex;flex-direction:column;overflow:hidden;position:relative;-webkit-animation:.4s cubic-bezier(.25,.8,.25,1) dialog-open;animation:.4s cubic-bezier(.25,.8,.25,1) dialog-open;border-radius:4px;box-sizing:border-box;box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);background:#fff;color:rgba(0,0,0,.87);width:auto;max-width:100%;height:auto;max-height:100%}@-webkit-keyframes dialog-open{0%{transform:translateX(50px)}100%{transform:none}}@keyframes dialog-open{0%{transform:translateX(50px)}100%{transform:none}}.ngneat-dialog-content.ngneat-dialog-resizable{resize:both}.ngneat-dialog-backdrop{position:fixed;display:flex;align-items:center;justify-content:center;top:0;left:0;bottom:0;right:0;height:100%;width:100%;padding:30px;z-index:1050;background:rgba(0,0,0,.32);-webkit-animation:.3s dialog-open-backdrop;animation:.3s dialog-open-backdrop}@-webkit-keyframes dialog-open-backdrop{0%{opacity:0}100%{opacity:1}}@keyframes dialog-open-backdrop{0%{opacity:0}100%{opacity:1}}.ngneat-drag-marker{position:absolute;left:0;top:0;cursor:move;width:100%;height:10px;z-index:1051}.ngneat-close-dialog{display:flex;align-items:center;justify-content:center;position:absolute;top:10px;cursor:pointer;right:10px;width:24px;height:24px;color:#5f6368;transition:color .2s ease-in-out;z-index:1051}.ngneat-close-dialog svg{width:12px;height:12px}.ngneat-close-dialog:hover{color:#5d9ff1}body.ngneat-dialog-hidden{overflow:hidden}"], encapsulation: 2 });
DialogComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef },
    { type: InternalDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [DIALOG_CONFIG,] }] },
    { type: Array, decorators: [{ type: Inject, args: [NODES_TO_INSERT,] }] }
];
__decorate([
    ViewChild('backdrop', { static: true })
], DialogComponent.prototype, "backdrop", void 0);
__decorate([
    ViewChild('dialog', { static: true })
], DialogComponent.prototype, "dialogElement", void 0);
DialogComponent = __decorate([ __param(0, Inject(DOCUMENT)),
    __param(3, Inject(DIALOG_CONFIG)),
    __param(4, Inject(NODES_TO_INSERT))
], DialogComponent);

const OVERFLOW_HIDDEN_CLASS = 'ngneat-dialog-hidden';
let DialogService = class DialogService {
    constructor(appRef, componentFactoryResolver, injector, document, defaultConfig, globalConfig) {
        this.appRef = appRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.document = document;
        this.defaultConfig = defaultConfig;
        this.globalConfig = globalConfig;
        this.dialogs = [];
        this.dialogFactory = this.componentFactoryResolver.resolveComponentFactory(DialogComponent);
    }
    closeAll() {
        this.dialogs.forEach(dialog => dialog.close());
    }
    success(content, config = {}) {
        const configWithDefaults = this.mergeConfigWithContent(this.applyDefaultSize(config), content);
        return this.open(configWithDefaults.success.component, configWithDefaults);
    }
    confirm(content, config = {}) {
        const configWithDefaults = this.mergeConfigWithContent(this.applyDefaultSize(config), content);
        return this.open(configWithDefaults.confirm.component, configWithDefaults);
    }
    error(content, config = {}) {
        const configWithDefaults = this.mergeConfigWithContent(this.applyDefaultSize(config), content);
        return this.open(configWithDefaults.error.component, configWithDefaults);
    }
    open(componentOrTemplate, config = {}) {
        var _a;
        const configWithDefaults = this.mergeConfig(config);
        (_a = configWithDefaults.onOpen) === null || _a === void 0 ? void 0 : _a.call(configWithDefaults);
        const dialogRef = new InternalDialogRef({
            id: configWithDefaults.id,
            data: configWithDefaults.data,
            backdropClick$: new Subject()
        });
        const params = {
            config: configWithDefaults,
            dialogRef
        };
        this.throwIfIDAlreadyExists(configWithDefaults.id);
        this.dialogs.push(dialogRef);
        if (this.dialogs.length === 1) {
            this.document.body.classList.add(OVERFLOW_HIDDEN_CLASS);
        }
        return componentOrTemplate instanceof TemplateRef
            ? this.openTemplate(componentOrTemplate, params)
            : typeof componentOrTemplate === 'function'
                ? this.openComponent(componentOrTemplate, params)
                : this.throwMustBeAComponentOrATemplateRef(componentOrTemplate);
    }
    openTemplate(template, { config, dialogRef }) {
        var _a;
        const context = {
            $implicit: dialogRef,
            config
        };
        const view = ((_a = config.vcr) === null || _a === void 0 ? void 0 : _a.createEmbeddedView(template, context)) || template.createEmbeddedView(context);
        return this.attach({
            dialogRef,
            config,
            ref: template,
            view,
            attachToApp: !config.vcr
        });
    }
    openComponent(component, { config, dialogRef }) {
        var _a;
        const factory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = factory.create(Injector.create({
            providers: [
                {
                    provide: DialogRef,
                    useValue: dialogRef
                },
                {
                    provide: DIALOG_CONFIG,
                    useValue: config
                }
            ],
            parent: ((_a = config.vcr) === null || _a === void 0 ? void 0 : _a.injector) || this.injector
        }));
        return this.attach({
            dialogRef,
            config,
            ref: componentRef,
            view: componentRef.hostView,
            attachToApp: true
        });
    }
    attach({ dialogRef, config, ref, view, attachToApp }) {
        const dialog = this.createDialog(config, dialogRef, view);
        const container = config.container instanceof ElementRef ? config.container.nativeElement : config.container;
        const hooks = {
            after: new Subject()
        };
        const onClose = (result) => {
            var _a, _b;
            (_b = (_a = this.globalConfig).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
            this.dialogs = this.dialogs.filter(({ id }) => dialogRef.id !== id);
            container.removeChild(dialog.location.nativeElement);
            this.appRef.detachView(dialog.hostView);
            this.appRef.detachView(view);
            dialog.destroy();
            view.destroy();
            dialogRef.backdropClick$.complete();
            dialogRef.mutate({
                ref: null,
                onClose: null,
                afterClosed$: null,
                backdropClick$: null,
                beforeCloseGuards: null
            });
            hooks.after.next(result);
            hooks.after.complete();
            if (this.dialogs.length === 0) {
                this.document.body.classList.remove(OVERFLOW_HIDDEN_CLASS);
            }
        };
        dialogRef.mutate({
            id: config.id,
            data: config.data,
            ref,
            onClose,
            afterClosed$: hooks.after.asObservable()
        });
        container.appendChild(dialog.location.nativeElement);
        this.appRef.attachView(dialog.hostView);
        if (attachToApp) {
            this.appRef.attachView(view);
        }
        return dialogRef.asDialogRef();
    }
    createDialog(config, dialogRef, view) {
        return this.dialogFactory.create(Injector.create({
            providers: [
                {
                    provide: InternalDialogRef,
                    useValue: dialogRef
                },
                {
                    provide: DIALOG_CONFIG,
                    useValue: config
                },
                {
                    provide: NODES_TO_INSERT,
                    useValue: view.rootNodes
                }
            ],
            parent: this.injector
        }));
    }
    mergeConfig(config) {
        var _a;
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.defaultConfig), { id: nanoid() }), this.globalConfig), this.cleanConfig(config)), { sizes: Object.assign(Object.assign(Object.assign({}, this.defaultConfig.sizes), (_a = this.globalConfig) === null || _a === void 0 ? void 0 : _a.sizes), config === null || config === void 0 ? void 0 : config.sizes) });
    }
    mergeConfigWithContent(config, content) {
        const _a = this.mergeConfig(config), { data } = _a, configWithDefaults = __rest(_a, ["data"]);
        return Object.assign(Object.assign({}, configWithDefaults), { data: Object.assign(Object.assign({}, data), { [DialogContentSymbol]: this.isTemplateOrString(content)
                    ? {
                        title: null,
                        body: {
                            type: this.getTypeOfContent(content),
                            content
                        }
                    }
                    : Object.entries(content).reduce((acc, [key, value]) => {
                        acc[key] = {
                            type: this.getTypeOfContent(value),
                            content: value
                        };
                        return acc;
                    }, {}) }) });
    }
    cleanConfig(config) {
        return Object.entries(config).reduce((cleanConfig, [key, value]) => {
            if (value != null) {
                cleanConfig[key] = value;
            }
            return cleanConfig;
        }, {});
    }
    isTemplateOrString(content) {
        return content instanceof TemplateRef || typeof content === 'string';
    }
    getTypeOfContent(content) {
        return content instanceof TemplateRef ? 'template' : 'string';
    }
    throwMustBeAComponentOrATemplateRef(value) {
        throw new TypeError(`Dialog must receive a Component or a TemplateRef, but this has been passed instead: ${value}`);
    }
    throwIfIDAlreadyExists(id) {
        if (this.dialogs.find(dialog => dialog.id === id)) {
            throw new Error(`Please, ID must be unique, but there is already a dialog created with this ID: ${id}`);
        }
    }
    applyDefaultSize(config) {
        return Object.assign(Object.assign({}, config), { size: config.size || 'sm' });
    }
};
DialogService.ɵfac = function DialogService_Factory(t) { return new (t || DialogService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DIALOG_DOCUMENT_REF), ɵngcc0.ɵɵinject(DIALOG_CONFIG), ɵngcc0.ɵɵinject(GLOBAL_DIALOG_CONFIG)); };
DialogService.ctorParameters = () => [
    { type: ApplicationRef },
    { type: ComponentFactoryResolver },
    { type: Injector },
    { type: undefined, decorators: [{ type: Inject, args: [DIALOG_DOCUMENT_REF,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DIALOG_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [GLOBAL_DIALOG_CONFIG,] }] }
];
DialogService.ɵprov = ɵɵdefineInjectable({ factory: function DialogService_Factory() { return new DialogService(ɵɵinject(ApplicationRef), ɵɵinject(ComponentFactoryResolver), ɵɵinject(INJECTOR), ɵɵinject(DIALOG_DOCUMENT_REF), ɵɵinject(DIALOG_CONFIG), ɵɵinject(GLOBAL_DIALOG_CONFIG)); }, token: DialogService, providedIn: "root" });
DialogService = __decorate([ __param(3, Inject(DIALOG_DOCUMENT_REF)),
    __param(4, Inject(DIALOG_CONFIG)),
    __param(5, Inject(GLOBAL_DIALOG_CONFIG))
], DialogService);
function nanoid() {
    return Math.random()
        .toString(36)
        .substring(7);
}

let DialogCloseDirective = class DialogCloseDirective {
    constructor(ref, host, dialogService) {
        this.ref = ref;
        this.host = host;
        this.dialogService = dialogService;
    }
    ngOnInit() {
        this.ref = this.ref || this.getRefFromParent();
    }
    onClose() {
        this.ref.close(this.dialogClose);
    }
    getRefFromParent() {
        let parent = this.host.nativeElement.parentElement;
        while (parent && parent.localName !== 'ngneat-dialog') {
            parent = parent.parentElement;
        }
        return parent ? this.dialogService.dialogs.find(({ id }) => id === parent.id) : null;
    }
};
DialogCloseDirective.ɵfac = function DialogCloseDirective_Factory(t) { return new (t || DialogCloseDirective)(ɵngcc0.ɵɵdirectiveInject(DialogRef, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DialogService)); };
DialogCloseDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DialogCloseDirective, selectors: [["", "dialogClose", ""]], hostBindings: function DialogCloseDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DialogCloseDirective_click_HostBindingHandler() { return ctx.onClose(); });
    } }, inputs: { dialogClose: "dialogClose" } });
DialogCloseDirective.ctorParameters = () => [
    { type: DialogRef, decorators: [{ type: Optional }] },
    { type: ElementRef },
    { type: DialogService }
];
__decorate([
    Input()
], DialogCloseDirective.prototype, "dialogClose", void 0);
__decorate([
    HostListener('click')
], DialogCloseDirective.prototype, "onClose", null);
DialogCloseDirective = __decorate([ __param(0, Optional())
], DialogCloseDirective);

let DialogDraggableDirective = class DialogDraggableDirective {
    constructor(host, zone, renderer) {
        this.host = host;
        this.zone = zone;
        this.renderer = renderer;
        this.dialogDragEnabled = false;
        this.dragged = new EventEmitter();
        this.delta = { x: 0, y: 0 };
        this.offset = { x: 0, y: 0 };
        this.enabled = true;
        this.destroy$ = new Subject();
    }
    set dialogDragOffset(offset) {
        this.reset(offset);
    }
    ngAfterViewInit() {
        if (!this.enabled) {
            return;
        }
        this.init();
    }
    ngOnChanges() {
        if (!this.enabled && this.dialogDragEnabled && this.dialogDragTarget) {
            this.enabled = true;
            /** determine if the component has been init by the handle variable */
            if (this.handle) {
                this.renderer.setStyle(this.handle, 'cursor', 'move');
            }
            else if (this.enabled) {
                this.init();
            }
        }
        if (!this.dialogDragEnabled) {
            this.enabled = false;
            if (this.handle) {
                this.renderer.setStyle(this.handle, 'cursor', '');
            }
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
    reset(offset) {
        const defaultValues = { x: 0, y: 0 };
        this.offset = Object.assign(Object.assign({}, defaultValues), offset);
        this.delta = Object.assign({}, defaultValues);
        this.translate();
    }
    setupEvents() {
        this.zone.runOutsideAngular(() => {
            const mousedown$ = fromEvent(this.handle, 'mousedown');
            const mousemove$ = fromEvent(document, 'mousemove');
            const mouseup$ = fromEvent(document, 'mouseup');
            const mousedrag$ = mousedown$.pipe(filter(() => this.enabled), map(event => ({
                startX: event.clientX,
                startY: event.clientY
            })), switchMap(({ startX, startY }) => mousemove$.pipe(map(event => {
                event.preventDefault();
                this.delta = {
                    x: event.clientX - startX,
                    y: event.clientY - startY
                };
            }), takeUntil(mouseup$))), takeUntil(this.destroy$));
            mousedrag$.subscribe(() => {
                if (this.delta.x === 0 && this.delta.y === 0) {
                    return;
                }
                this.translate();
            });
            mouseup$
                .pipe(filter(() => this.enabled), 
            /** Only emit change if the element has moved */
            filter(() => this.delta.x !== 0 || this.delta.y !== 0), takeUntil(this.destroy$))
                .subscribe(() => {
                this.offset.x += this.delta.x;
                this.offset.y += this.delta.y;
                this.dragged.emit(this.offset);
                this.delta = { x: 0, y: 0 };
            });
        });
    }
    translate() {
        if (this.target) {
            this.zone.runOutsideAngular(() => {
                requestAnimationFrame(() => {
                    const transform = `translate(${this.offset.x + this.delta.x}px, ${this.offset.y + this.delta.y}px)`;
                    this.renderer.setStyle(this.target, 'transform', transform);
                });
            });
        }
    }
    /**
     * Init the directive
     */
    init() {
        if (!this.dialogDragTarget) {
            throw new Error('You need to specify the drag target');
        }
        this.handle =
            this.dialogDragHandle instanceof Element
                ? this.dialogDragHandle
                : typeof this.dialogDragHandle === 'string' && this.dialogDragHandle
                    ? document.querySelector(this.dialogDragHandle)
                    : this.host.nativeElement;
        /** add the move cursor */
        if (this.handle && this.enabled) {
            this.renderer.setStyle(this.handle, 'cursor', 'move');
        }
        this.target =
            this.dialogDragTarget instanceof HTMLElement
                ? this.dialogDragTarget
                : document.querySelector(this.dialogDragTarget);
        this.setupEvents();
        this.translate();
    }
};
DialogDraggableDirective.ɵfac = function DialogDraggableDirective_Factory(t) { return new (t || DialogDraggableDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DialogDraggableDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DialogDraggableDirective, selectors: [["", "dialogDraggable", ""]], inputs: { dialogDragEnabled: "dialogDragEnabled", dialogDragOffset: "dialogDragOffset", dialogDragHandle: "dialogDragHandle", dialogDragTarget: "dialogDragTarget" }, outputs: { dragged: "dragged" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DialogDraggableDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: Renderer2 }
];
__decorate([
    Input()
], DialogDraggableDirective.prototype, "dialogDragHandle", void 0);
__decorate([
    Input()
], DialogDraggableDirective.prototype, "dialogDragTarget", void 0);
__decorate([
    Input()
], DialogDraggableDirective.prototype, "dialogDragEnabled", void 0);
__decorate([
    Input()
], DialogDraggableDirective.prototype, "dialogDragOffset", null);
__decorate([
    Output()
], DialogDraggableDirective.prototype, "dragged", void 0);

var DialogModule_1;
const BuiltIns = [BaseDialogComponent, SuccessDialogComponent, ConfirmDialogComponent, ErrorDialogComponent];
let DialogModule = DialogModule_1 = class DialogModule {
    static forRoot(config = {}) {
        return {
            ngModule: DialogModule_1,
            providers: [
                {
                    provide: GLOBAL_DIALOG_CONFIG,
                    useValue: config
                }
            ]
        };
    }
};
DialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DialogModule_Factory(t) { return new (t || DialogModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaseDialogComponent, [{
        type: Component,
        args: [{
                selector: 'ngneat-dialog-base',
                template: `
    <div class="dialog">
      <div class="dialog-header">
        <span class="dialog-icon">
          <ng-content select=".icon"></ng-content>
        </span>
        <ng-container [ngSwitch]="title?.type">
          <h2 *ngSwitchCase="'string'" [innerHTML]="title.content"></h2>
          <h2 *ngSwitchCase="'template'">
            <ng-container *ngTemplateOutlet="title.content; context: context"></ng-container>
          </h2>
        </ng-container>
      </div>

      <div class="dialog-content" [ngSwitch]="body.type">
        <p *ngSwitchCase="'string'" [class.with-title]="title" [innerHTML]="body.content"></p>
        <p *ngSwitchCase="'template'" [class.with-title]="title">
          <ng-container *ngTemplateOutlet="body.content; context: context"></ng-container>
        </p>
      </div>

      <div class="dialog-footer">
        <ng-content select=".btn"></ng-content>
      </div>
    </div>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;flex-direction:column;overflow:hidden;flex-grow:1}.dialog{flex-grow:1;display:flex;align-items:center;flex-direction:column;justify-content:flex-start;overflow:hidden}.dialog-header{position:relative;display:flex;flex-direction:row;align-items:center;width:100%;margin:0;padding:18px 40px 10px 30px}.dialog-header .dialog-icon ::ng-deep{display:flex}.dialog-header .dialog-icon ::ng-deep .icon{width:24px;margin-right:10px}.dialog-header .dialog-icon ::ng-deep .icon-success{fill:#72c140}.dialog-header .dialog-icon ::ng-deep .icon-question{fill:#f0af41}.dialog-header .dialog-icon ::ng-deep .icon-error{fill:#e74c3c}.dialog-header h2{font-size:1.2rem;font-weight:700;margin:0}.dialog-content{width:100%;flex-grow:1;overflow:auto;position:relative;display:flex;flex-direction:column;padding:0 30px 30px}.dialog-content p{font-size:.875rem;line-height:1.75;margin:5px 0}.dialog-content .with-title{padding-left:35px}.dialog-footer ::ng-deep{display:flex;width:100%;justify-content:flex-end;padding:17px 30px 16px;border-top:1px solid #f1f2f5}.dialog-footer ::ng-deep .btn{margin-right:10px;padding:10px 18px;border:0;border-radius:4px;cursor:pointer}.dialog-footer ::ng-deep .btn:focus{outline:0}.dialog-footer ::ng-deep .btn:last-child{margin-right:0}.dialog-footer ::ng-deep .btn-success{background-color:#4091f7;color:#fff}.dialog-footer ::ng-deep .btn-error{background-color:#e74c3c;color:#fff}.dialog-footer ::ng-deep .btn-cancel{background-color:#fff;border:2px solid #4091f7;color:#4091f7}"]
            }]
    }], function () { return [{ type: DialogRef }]; }, null); })();
const ɵSuccessDialogComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(SuccessDialogComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SuccessDialogComponent, [{
        type: Component,
        args: [{
                selector: 'ngneat-dialog-success',
                template: `
    <ngneat-dialog-base>
      <svg class="icon icon-success" x="0px" y="0px" viewBox="0 0 496 496">
        <g>
          <path
            d="M248,0C111.033,0,0,111.033,0,248s111.033,248,248,248s248-111.033,248-248C495.841,111.099,384.901,0.159,248,0z      M248,480C119.87,480,16,376.13,16,248S119.87,16,248,16s232,103.87,232,232C479.859,376.072,376.072,479.859,248,480z"
          />
          <path
            d="M370.344,158.344L208,320.688l-82.344-82.344c-3.178-3.07-8.242-2.982-11.312,0.196c-2.994,3.1-2.994,8.015,0,11.116     l88,88c3.124,3.123,8.188,3.123,11.312,0l168-168c3.07-3.178,2.982-8.242-0.196-11.312     C378.359,155.35,373.444,155.35,370.344,158.344z"
          />
        </g>
      </svg>

      <button class="btn btn-success ngneat-dialog-primary-btn" (click)="ref.close()">OK</button>
    </ngneat-dialog-base>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;flex-direction:column;flex-grow:1;overflow:hidden}"]
            }]
    }], null, null); })();
const ɵConfirmDialogComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(ConfirmDialogComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmDialogComponent, [{
        type: Component,
        args: [{
                selector: 'ngneat-dialog-confirm',
                template: `
    <ngneat-dialog-base>
      <svg class="icon icon-question" x="0px" y="0px" viewBox="0 0 512 512">
        <g>
          <circle cx="256" cy="378.5" r="25" />
          <path
            d="M256,0C114.516,0,0,114.497,0,256c0,141.484,114.497,256,256,256c141.484,0,256-114.497,256-256     C512,114.516,397.503,0,256,0z M256,472c-119.377,0-216-96.607-216-216c0-119.377,96.607-216,216-216     c119.377,0,216,96.607,216,216C472,375.377,375.393,472,256,472z"
          />
          <path
            d="M256,128.5c-44.112,0-80,35.888-80,80c0,11.046,8.954,20,20,20s20-8.954,20-20c0-22.056,17.944-40,40-40     c22.056,0,40,17.944,40,40c0,22.056-17.944,40-40,40c-11.046,0-20,8.954-20,20v50c0,11.046,8.954,20,20,20     c11.046,0,20-8.954,20-20v-32.531c34.466-8.903,60-40.26,60-77.469C336,164.388,300.112,128.5,256,128.5z"
          />
        </g>
      </svg>

      <button class="btn btn-cancel ngneat-dialog-secondary-btn" (click)="ref.close(false)">Cancel</button>
      <button class="btn btn-success ngneat-dialog-primary-btn" (click)="ref.close(true)">OK</button>
    </ngneat-dialog-base>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;flex-direction:column;flex-grow:1;overflow:hidden}"]
            }]
    }], null, null); })();
const ɵErrorDialogComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(ErrorDialogComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorDialogComponent, [{
        type: Component,
        args: [{
                selector: 'ngneat-dialog-error',
                template: `
    <ngneat-dialog-base>
      <svg class="icon icon-error" x="0px" y="0px" viewBox="0 0 512 512">
        <g>
          <path
            d="M256,0C114.508,0,0,114.497,0,256c0,141.493,114.497,256,256,256c141.492,0,256-114.497,256-256    C512,114.507,397.503,0,256,0z M256,472c-119.384,0-216-96.607-216-216c0-119.385,96.607-216,216-216    c119.384,0,216,96.607,216,216C472,375.385,375.393,472,256,472z"
          />
          <path
            d="M343.586,315.302L284.284,256l59.302-59.302c7.81-7.81,7.811-20.473,0.001-28.284c-7.812-7.811-20.475-7.81-28.284,0    L256,227.716l-59.303-59.302c-7.809-7.811-20.474-7.811-28.284,0c-7.81,7.811-7.81,20.474,0.001,28.284L227.716,256    l-59.302,59.302c-7.811,7.811-7.812,20.474-0.001,28.284c7.813,7.812,20.476,7.809,28.284,0L256,284.284l59.303,59.302    c7.808,7.81,20.473,7.811,28.284,0C351.398,335.775,351.397,323.112,343.586,315.302z"
          />
        </g>
      </svg>

      <button class="btn btn-error ngneat-dialog-primary-btn" (click)="ref.close()">OK</button>
    </ngneat-dialog-base>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;flex-direction:column;flex-grow:1;overflow:hidden}"]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'ngneat-dialog',
                template: `
    <div
      #backdrop
      class="ngneat-dialog-backdrop"
      [hidden]="!config.backdrop"
      [class.ngneat-dialog-backdrop-visible]="config.backdrop"
    >
      <div #dialog class="ngneat-dialog-content" [class.ngneat-dialog-resizable]="config.resizable" [ngStyle]="styles">
        <div
          *ngIf="config.draggable"
          class="ngneat-drag-marker"
          dialogDraggable
          [dialogDragEnabled]="true"
          [dialogDragTarget]="dialog"
        ></div>
        <div class="ngneat-close-dialog" *ngIf="config.enableClose && config.closeButton" (click)="closeDialog()">
          <svg viewBox="0 0 329.26933 329" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="currentColor"
              d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"
            />
          </svg>
        </div>
      </div>
    </div>
  `,
                encapsulation: ViewEncapsulation.None,
                styles: [".ngneat-dialog-content{display:flex;flex-direction:column;overflow:hidden;position:relative;-webkit-animation:.4s cubic-bezier(.25,.8,.25,1) dialog-open;animation:.4s cubic-bezier(.25,.8,.25,1) dialog-open;border-radius:4px;box-sizing:border-box;box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);background:#fff;color:rgba(0,0,0,.87);width:auto;max-width:100%;height:auto;max-height:100%}@-webkit-keyframes dialog-open{0%{transform:translateX(50px)}100%{transform:none}}@keyframes dialog-open{0%{transform:translateX(50px)}100%{transform:none}}.ngneat-dialog-content.ngneat-dialog-resizable{resize:both}.ngneat-dialog-backdrop{position:fixed;display:flex;align-items:center;justify-content:center;top:0;left:0;bottom:0;right:0;height:100%;width:100%;padding:30px;z-index:1050;background:rgba(0,0,0,.32);-webkit-animation:.3s dialog-open-backdrop;animation:.3s dialog-open-backdrop}@-webkit-keyframes dialog-open-backdrop{0%{opacity:0}100%{opacity:1}}@keyframes dialog-open-backdrop{0%{opacity:0}100%{opacity:1}}.ngneat-drag-marker{position:absolute;left:0;top:0;cursor:move;width:100%;height:10px;z-index:1051}.ngneat-close-dialog{display:flex;align-items:center;justify-content:center;position:absolute;top:10px;cursor:pointer;right:10px;width:24px;height:24px;color:#5f6368;transition:color .2s ease-in-out;z-index:1051}.ngneat-close-dialog svg{width:12px;height:12px}.ngneat-close-dialog:hover{color:#5d9ff1}body.ngneat-dialog-hidden{overflow:hidden}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef }, { type: InternalDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DIALOG_CONFIG]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [NODES_TO_INSERT]
            }] }]; }, { backdrop: [{
            type: ViewChild,
            args: ['backdrop', { static: true }]
        }], dialogElement: [{
            type: ViewChild,
            args: ['dialog', { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: undefined, decorators: [{
                type: Inject,
                args: [DIALOG_DOCUMENT_REF]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DIALOG_CONFIG]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [GLOBAL_DIALOG_CONFIG]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogCloseDirective, [{
        type: Directive,
        args: [{
                selector: '[dialogClose]'
            }]
    }], function () { return [{ type: DialogRef, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: DialogService }]; }, { onClose: [{
            type: HostListener,
            args: ['click']
        }], dialogClose: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogDraggableDirective, [{
        type: Directive,
        args: [{
                selector: '[dialogDraggable]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }]; }, { dialogDragEnabled: [{
            type: Input
        }], dragged: [{
            type: Output
        }], dialogDragOffset: [{
            type: Input
        }], dialogDragHandle: [{
            type: Input
        }], dialogDragTarget: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DialogModule, { declarations: function () { return [DialogComponent, DialogCloseDirective, DialogDraggableDirective, BaseDialogComponent, SuccessDialogComponent, ConfirmDialogComponent, ErrorDialogComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DialogComponent, DialogCloseDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                declarations: [DialogComponent, DialogCloseDirective, DialogDraggableDirective, BuiltIns],
                imports: [CommonModule],
                entryComponents: [DialogComponent],
                exports: [DialogComponent, DialogCloseDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of dialog
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DIALOG_CONFIG, DIALOG_DOCUMENT_REF, DialogCloseDirective, DialogComponent, DialogContentSymbol, DialogModule, DialogRef, DialogService, InternalDialogRef as ɵa, GLOBAL_DIALOG_CONFIG as ɵb, NODES_TO_INSERT as ɵc, DialogDraggableDirective as ɵd, BaseDialogComponent as ɵe, SuccessDialogComponent as ɵf, ConfirmDialogComponent as ɵg, ErrorDialogComponent as ɵh };

//# sourceMappingURL=ngneat-dialog.js.map